import { removePinPoolNumber } from "../forms/cardGroups/pinPool/pin-pool-helpers";
import { PIN_POOL_FORM } from "../forms/cardGroups/form-cardgroup-types";

/**
 * Widget to display a list of Pin that can be removed from a Card Group
 * 
 * @param {any} pinPoolList the card group list array
 * @param {HTMLElement} container the parent container for the generated list of elements
 * 
 * @returns void
 */
export const newPinPoolWidget = ( id: string, container: HTMLElement ) => {
  let div = document.createElement('div');
  div.className = `pin-pool-widget key_${id}`; 
  div.id = `aafp_container-${id}`; 
  div.setAttribute('data-pin-number', String(id));      

  let divInnerLeft = document.createElement('div');
  divInnerLeft.className = 'pin-input';

  let pinNumberInput = document.createElement('input');
  pinNumberInput.type = 'number';
  pinNumberInput.className = 'aafp_input aafp_color-theme-input pin_number form-control';
  pinNumberInput.id = `aafp_pin-number-${id}`;
  pinNumberInput.placeholder = 'Pin Number';
  pinNumberInput.setAttribute('required', 'true');

  let divInnerMiddle = document.createElement('div');
  divInnerMiddle.className = 'pin-description';

  let pinDescriptionInput = document.createElement('input');
  pinDescriptionInput.type = 'text';
  pinDescriptionInput.className = 'aafp_input aafp_color-theme-input form-control pin-desc';
  pinDescriptionInput.id = `aafp_pin-description-${id}`;
  pinDescriptionInput.placeholder = 'Pin Description (Optional)';
  pinDescriptionInput.oninput = function(e) {
    let input = e.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z0-9 ]/g, '');
  }
  pinDescriptionInput.maxLength = 127;

  let divInnerRight = document.createElement('div');
  divInnerRight.className = 'pin-remove';

  let pinButton = document.createElement('i');
  pinButton.className = `far fa-trash-alt element-remove-${id}`;
  pinButton.setAttribute('data-toggle', 'tooltip');
  pinButton.setAttribute('data-placement', 'bottom');
  pinButton.setAttribute('title', `Remove New Pin`);

  divInnerLeft.appendChild(pinNumberInput);
  divInnerMiddle.appendChild(pinDescriptionInput);
  divInnerRight.appendChild(pinButton);
  div.appendChild(divInnerLeft);
  div.appendChild(divInnerMiddle);
  div.appendChild(divInnerRight);

  container.appendChild(div);

  removePinPoolNumber(`.element-remove-${id}`, String(id));
}